import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Grid from '@mui/material/Grid'
import { Stack } from '@mui/material'
import { Checkbox } from '@carsys/form'
import { IShopWholesaler } from '@cbgms/api/modules/wholesaler'
import { IRootReducerState } from 'state/rootReducer'
import WholesalerCredentialField from './WholesalerCredentialField'
interface Props {
  wholesaler: IShopWholesaler
  orderAccountUUID?: string
  hideDoNotShowOnListOptions: boolean
  hideImage?: boolean
}

export const WholesalerCredentialFields: React.FC<Props> = ({
  wholesaler,
  orderAccountUUID,
  hideDoNotShowOnListOptions,
  hideImage = false,
  children
}) => {
  const { t } = useTranslation()
  const defaultOrderAccountUUID = useSelector((state: IRootReducerState) => state.settings.defaultOrderAccount.defaultOrderAccountUUID)

  return (
    <Grid item container spacing={1}>
      {!hideImage && (
        <Grid item xs={6}>
          <img src={wholesaler.LogoURL} width='100%' />
        </Grid>
      )}
      <Grid item xs={hideImage ? 12 : 6} data-testid='wholesaler-credential-fields'>
        <Stack spacing={1}>
          {children}
          {wholesaler.UserFields.map(field => (
            <WholesalerCredentialField key={field.Name} wholesaler={wholesaler} field={field} />
          ))}
          {!hideDoNotShowOnListOptions && (
            <Checkbox
              data-testid='selectable-on-list-checkbox-field'
              label={t('Configuration.DoNotShowOnList')}
              name='DoNotShowOnList'
              disabled={!!(orderAccountUUID && orderAccountUUID === defaultOrderAccountUUID)}
            />
          )}
        </Stack>
      </Grid>
    </Grid>
  )
}
